const Camera = () => {
  return (
    <svg width={27} height={20} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity=".4"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.208 2.868 18.41 5.682v-3.18C18.41 1.119 17.31 0 15.955 0h-13.5C1.095 0 0 1.12 0 2.503v14.994C0 18.882 1.099 20 2.454 20h13.501c1.358 0 2.454-1.12 2.454-2.503v-3.179l3.8 2.814a2.19 2.19 0 0 0 1.111.368h2.45c.686 0 1.23-.561 1.23-1.253V3.753c0-.692-.551-1.253-1.23-1.253h-2.45a2.16 2.16 0 0 0-1.112.368ZM2.455 17.5v-15h13.5v15h-13.5Zm2.454-3.75c0-.69.55-1.25 1.231-1.25h6.13c.679 0 1.23.555 1.23 1.25 0 .69-.55 1.25-1.23 1.25H6.14c-.68 0-1.23-.555-1.23-1.25ZM23.511 15l-5.087-3.762V8.762l5.083-3.765 1.038.001v10L23.512 15Z"
        fill="#fff"
      />
    </svg>
  );
};

export default Camera;
